import type { OverviewStore } from '../api/overview'

export type OverviewSortKey =
  | 'shop'
  | 'sales'
  | 'today'
  | 'grid'
  | 'worked'
  | 'diff'

export type OverviewSort = {
  key: OverviewSortKey
  direction: 'asc' | 'desc'
} | null

function valueFor(store: OverviewStore, key: OverviewSortKey): number | null {
  switch (key) {
    case 'sales':
      return store.sales_period_eur
    case 'today':
      return store.sales_today_eur
    case 'grid':
      return store.grid_hours
    case 'worked':
      return store.worked_hours
    case 'diff':
      return store.worked_hours != null && store.grid_hours != null
        ? store.worked_hours - store.grid_hours
        : null
    case 'shop':
      return null
  }
  return null
}

/**
 * Sort the General Overview shop rows.
 *
 * A missing figure always sinks to the bottom, whichever direction is active —
 * a shop without Shiftbase hours must never look like zero. Ties fall back to
 * the shop number so the order is stable across refreshes.
 */
export function sortOverviewStores(
  stores: OverviewStore[],
  sort: OverviewSort,
): OverviewStore[] {
  if (!sort) return stores
  const factor = sort.direction === 'asc' ? 1 : -1
  return [...stores].sort((a, b) => {
    if (sort.key === 'shop') {
      return factor * a.store_code.localeCompare(b.store_code)
    }
    const left = valueFor(a, sort.key)
    const right = valueFor(b, sort.key)
    if (left == null && right == null) return a.store_code.localeCompare(b.store_code)
    if (left == null) return 1
    if (right == null) return -1
    const delta = factor * (left - right)
    return delta !== 0 ? delta : a.store_code.localeCompare(b.store_code)
  })
}
